import React,{useEffect} from "react";
import { useGetCustomerReminderHistoryQuery } from "../../../Service/CustomerReminder";
import moment from "moment";


function CustomerReminderDetail(props) {
  const { id, data } = props;
  const pagi = {
    pageNo: 1,
    id: id || data.customerId,
  };
  const response = useGetCustomerReminderHistoryQuery(pagi || "", {
    refetchOnMountOrArgChange: true,
  });
// console.log(response);

useEffect(() => {
  // Fetch new data whenever the id prop changes
  response.refetch();
}, [data.id,data.customerId]);
// console.log(data);

  const renderComp = () => {
    return (<>
      <li>
        <span className="title mb-1">Reminder</span>
      </li>
      <li className="mt-3">
        <span className="sub-title">Next Reminder in</span>
      </li>
      <li className="date">
        <span style={{ fontWeight: "600", fontSize: "16px" }}>{moment(data?.appointmentDate).format(
                  "DD-MM-YYYY"
                )}</span>
      </li>
    </>)
  }

  return (
    <>
      {data.appointmentDate && renderComp()}
    </>
  );
}

export default React.memo(CustomerReminderDetail);
